import React, { useState, useCallback, useRef, useEffect } from 'react';
import PrimeUsersAuditLogView from './prime-users-audit-log.view';
import { useUpdateSubcontractorDBContext } from 'src/contexts/manage-subcontractor.context';
import { IORGDataTableQueryState } from 'shared-it-appmod-ui';
import { useContactPrimesContext } from 'src/contexts/contact-primes.context';

type Iprops = {
    openAuditLogs: boolean;
    handleOnDiscardAuditLogs: () => void;
    vendorId: number;
};
const PrimeUsersAuditLog: React.FC<Iprops> = ({
    openAuditLogs,
    handleOnDiscardAuditLogs,
    vendorId
}) => {
    const { state, actions } = useContactPrimesContext();
    const [loadinglog, setLoadinglog] = useState(false);
    const [queryParams, setQueryParams] = useState<IORGDataTableQueryState>();
   
    const fetchLogData = useCallback(
        async (params: IORGDataTableQueryState) => {
            setLoadinglog(true);

            const { page, limit } = params;
            const param =
                {
                    page: page,
                    limit: limit,
                    vendorId : vendorId
                } || queryParams;
            await actions?.spendDataAuditLogGet(param);
            setLoadinglog(false);
        },
        [actions]
    );



    const handleCancel = useCallback(() => {
        handleOnDiscardAuditLogs();
    }, []);
    return (
        <>
            <PrimeUsersAuditLogView
                data={state?.spendDataAuditLogGet?.data || []}
                openAuditLogs={openAuditLogs}
                handleClose={handleCancel}
                loadinglog={loadinglog}
                fetchLogData={fetchLogData}
                totalRecord={state?.spendDataAuditLogGet?.total_rows || 0}
            />

        </>
    );
};

export default PrimeUsersAuditLog;
